import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function fetchServerKey() {
  const { data } = await axios.get(`${API}/push/public-key`);
  const padding = "=".repeat((4 - (data.public_key.length % 4)) % 4);
  const raw = atob((data.public_key + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return { rawKey: Uint8Array.from([...raw].map((c) => c.charCodeAt(0))), pub: data.public_key };
}

async function subscribeAndSave(reg) {
  const { rawKey, pub } = await fetchServerKey();
  let sub = await reg.pushManager.getSubscription();
  if (sub && localStorage.getItem("rav-push-key") !== pub) {
    // La clé du serveur a changé (paire régénérée le 25/10/2026) : l'ancien
    // abonnement est invalide, on le remplace proprement.
    await sub.unsubscribe().catch(() => {});
    sub = null;
  }
  if (!sub) {
    try {
      sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: rawKey });
    } catch (e) {
      // Abonnement existant lié à une autre clé : on repart de zéro une fois.
      const old = await reg.pushManager.getSubscription();
      if (old) await old.unsubscribe().catch(() => {});
      sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: rawKey });
    }
  }
  const token = localStorage.getItem("rav-token");
  if (token) {
    const j = sub.toJSON();
    await axios.post(`${API}/push/subscribe`, { endpoint: j.endpoint, keys: j.keys }, { headers: { Authorization: `Bearer ${token}` } });
  }
  localStorage.setItem("rav-push-key", pub);
  return sub;
}

// Activation des notifications push (Web Push). Sur iPhone : possible UNIQUEMENT
// dans l'app installée sur l'écran d'accueil (iOS 16.4+) — sinon la permission
// reste utile pour les notifications visibles dans l'app.
// Renvoie : "granted" | "no-sw-push" (permission OK, push indisponible ici) |
//           "denied" | "unsupported"
export async function enablePushNotifications() {
  if (typeof Notification === "undefined" || !("serviceWorker" in navigator)) return "unsupported";
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return "denied";
  try {
    const reg = await navigator.serviceWorker.ready;
    await subscribeAndSave(reg);
    return "granted";
  } catch {
    return "no-sw-push"; // ex. iPhone dans Safari sans app installée
  }
}

export function pushPermission() {
  return typeof Notification === "undefined" ? "unsupported" : Notification.permission;
}

// Re-synchronisation silencieuse au démarrage de l'app : si la permission a déjà été
// accordée, on renvoie l'abonnement push au serveur (répare les abonnements créés
// pendant une déconnexion — sans redemander la permission).
export async function syncPushSubscription() {
  try {
    if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
    if (!("serviceWorker" in navigator)) return;
    const token = localStorage.getItem("rav-token");
    if (!token) return;
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    // Ré-abonnement automatique si la clé serveur a changé (paire régénérée)
    await subscribeAndSave(reg);
  } catch {
    /* silencieux : la synchro sera retentée à la prochaine ouverture */
  }
}
